import React, { useEffect, useRef } from 'react';
import { PageShell } from './PanelLayout';

const parseMessageData = (data) => {
  if (!data) return null;

  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (error) {
      return data;
    }
  }

  if (typeof data === 'object') {
    return data;
  }

  return null;
};

const PublicFormIframe = ({ applicationTitle, iframeHtml, onMessage }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handleMessage = (event) => {
      if (event.source !== iframeRef.current?.contentWindow) return;

      const payload = parseMessageData(event.data);
      if (!payload) return;

      onMessage?.({
        origin: event.origin,
        payload,
      });
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onMessage]);

  return (
    <PageShell>
      <iframe
        ref={iframeRef}
        title={applicationTitle}
        srcDoc={iframeHtml}
        allow="fullscreen *; clipboard-write *; camera *; microphone *; geolocation *; payment *"
        referrerPolicy="no-referrer-when-downgrade"
        className="h-full min-h-[calc(100vh-5rem)] w-full flex-1 border-0"
      />
    </PageShell>
  );
};

export default PublicFormIframe;
